import { render } from "./allCategories.vue?vue&type=template&id=be9ef7e2&ts=true"
import script from "./allCategories.vue?vue&type=script&lang=ts"
export * from "./allCategories.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__